import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  salaryStructures: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    total_pages: 1,
  },
  selectedSalaryStructure: null,
};

const salaryStructureSlice = createSlice({
  name: "companySalaryStructure",
  initialState,
  reducers: {
    // Get Salary Structures
    getSalaryStructuresStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getSalaryStructuresSuccess: (state, action) => {
      state.loading = false;
      state.salaryStructures = action.payload.structures || [];
      state.pagination = action.payload.pagination || initialState.pagination;
      state.error = null;
    },
    getSalaryStructuresFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Salary Structure
    createSalaryStructureStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createSalaryStructureSuccess: (state, action) => {
      state.loading = false;
      state.salaryStructures.push(action.payload);
      state.error = null;
    },
    createSalaryStructureFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Salary Structure
    updateSalaryStructureStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateSalaryStructureSuccess: (state, action) => {
      state.loading = false;
      const index = state.salaryStructures.findIndex(
        (structure) => structure.id === action.payload.id,
      );
      if (index !== -1) {
        state.salaryStructures[index] = action.payload;
      }
      state.error = null;
    },
    updateSalaryStructureFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete Salary Structure
    deleteSalaryStructureStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteSalaryStructureSuccess: (state, action) => {
      state.loading = false;
      state.salaryStructures = state.salaryStructures.filter(
        (structure) => structure.id !== action.payload,
      );
      state.error = null;
    },
    deleteSalaryStructureFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Salary Structure
    setSelectedSalaryStructure: (state, action) => {
      state.selectedSalaryStructure = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getSalaryStructuresStart,
  getSalaryStructuresSuccess,
  getSalaryStructuresFailure,
  createSalaryStructureStart,
  createSalaryStructureSuccess,
  createSalaryStructureFailure,
  updateSalaryStructureStart,
  updateSalaryStructureSuccess,
  updateSalaryStructureFailure,
  deleteSalaryStructureStart,
  deleteSalaryStructureSuccess,
  deleteSalaryStructureFailure,
  setSelectedSalaryStructure,
  clearError,
} = salaryStructureSlice.actions;

export default salaryStructureSlice.reducer;
